import React from 'react';
import PropTypes from 'prop-types';
import {
  Typography,
  Button,
  Alert,
} from '@one-thd/sui-atomic-components';
import { SweepstakesDrawer } from './SweepstakesDrawer';
import { SweepstakesMarkdown } from '../SweepstakesMarkdown';
import { SWEEPSTAKES_CONSTANTS } from '../../../core/Constants';

export const SweepstakesStepDrawer = ({
  isOpen,
  onClose,
  onBack,
  step,
}) => {
  const [showCtaAlert, setShowCtaAlert] = React.useState(false);

  if (!step) return null;

  const handleCtaClick = () => {
    setShowCtaAlert(true);
    setTimeout(() => setShowCtaAlert(false), 3000);
  };

  // Split instructions into main steps and important details sections
  const splitInstructions = (instructions) => {
    if (!instructions) return { mainSteps: '', importantDetails: '' };

    const parts = instructions.split('**Important Details');
    const mainSteps = parts[0]?.trim() || '';
    const importantDetails = parts[1] ? `**Important Details${parts[1]}` : '';

    return { mainSteps, importantDetails };
  };

  const defaultInstructions = { mainSteps: '', importantDetails: '' };
  const instructionsData = step.instructions ? splitInstructions(step.instructions) : defaultInstructions;
  const { mainSteps, importantDetails } = instructionsData;

  const footerContent = step.ctaTitle && (
    <Button
      variant="primary"
      fullWidth
      onClick={handleCtaClick}
      data-testid="sweepstakes-step-cta-button"
    >
      {step.ctaTitle}
    </Button>
  );

  return (
    <SweepstakesDrawer
      isOpen={isOpen}
      onClose={onClose}
      onBack={onBack}
      drawerTitle={SWEEPSTAKES_CONSTANTS.DRAWER_TITLES.SWEEPSTAKES_DETAILS}
      sweepstakesTitle={step.title}
      logoUrl={step.iconUrl}
      footerContent={footerContent}
      testId="sweepstakes-step-drawer"
    >
      <div className="sui-space-y-4" data-testid="sweepstakes-step-content">
        {showCtaAlert && (
          <Alert status="info" className="sui-mb-4">
            <Typography variant="body-base">
              {step.ctaTitle} button was clicked! This is just a demo.
            </Typography>
          </Alert>
        )}
        {step.description && (
          <div>
            {step.description}
          </div>
        )}
        {mainSteps && (
          <div>
            <SweepstakesMarkdown markdownText={mainSteps} />
          </div>
        )}
        {importantDetails && (
          <div className="sui-mt-6">
            <SweepstakesMarkdown markdownText={importantDetails} />
          </div>
        )}
      </div>
    </SweepstakesDrawer>
  );
};

SweepstakesStepDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  step: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    description: PropTypes.string,
    instructions: PropTypes.string,
    ctaTitle: PropTypes.string,
    iconUrl: PropTypes.string,
  }),
};

SweepstakesStepDrawer.defaultProps = {
  onBack: null,
  step: null,
};